<template>
  <div :id="myChartId" style="height: 120px; width: 120px; margin: 30px 26px;"></div>
</template>

<script>
  export default {
    name: "eberOperationPie",
    props: {
      operationData: {
        type: Object,
        default () {
          return {name: 1};
        }
      },
    },
    data () {
      return {
        myChartId: this.operationData.id + 'operation',
        myChart: null
      }
    },
    created() {
    },
    mounted(){
      this.drawPie();
    },
    watch:{
      operationData(){
        this.changePie();
      }
    },
    methods: {
      drawPie() {
        this.myChart = this.$echarts.init(document.getElementById(this.myChartId));
        // 绘制图表
        this.myChart.setOption({
          tooltip: {
            trigger: 'item'
          },
          color: ['#7ecf51', '#eecf5f', '#61a5e8'],
          grid:{
            top:"0",
            left:"0",
            right:"0",
            bottom:"0",
            width: '120px',
            height: '120px'
          },
          series: [
            {
              name:'手术统计',
              type:'pie',
              radius: ['85%', '100%'],
              avoidLabelOverlap: false,
              hoverOffset: 0.5,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data:[]
            }
          ]
        });
        this.changePie();
        this.myChart.resize();
      },
      changePie() {
        if (this.operationData.operatorCount.val === 0 && this.operationData.firstCount.val === 0 && this.operationData.secondCount.val === 0) {
          this.myChart.setOption({
            series: [{
              data:[{
                value: this.operationData.operatorCount.val,
                name: '手术总计',
                itemStyle: {
                  color: '#e4e4e4'
                }
              }]
            }]
          });
        } else {
          this.myChart.setOption({
            series: [{
              data:[{value: this.operationData.operatorCount.val, name:'主刀'},
                {value: this.operationData.firstCount.val, name:'一助'},
                {value: this.operationData.secondCount.val, name:'二助'}]
            }]
          });
        }
      }
    }
  }
</script>

<style scoped>
</style>
